import React, { createContext, useContext, useState } from "react";

// Create the context
const EditStateContext = createContext<{
  isDirty: boolean;
  isInvalid: boolean;
  setIsDirty: (dirty: boolean) => void;
  setIsInvalid: (invalid: boolean) => void;
  invalidInfo: string;
  setInvalidInfo: (info: string) => void;
} | null>(null);

// Custom hook to use the context
export const useEditState = () => {
  const context = useContext(EditStateContext);
  if (!context) {
    throw new Error("useEditState must be used within an EditStateProvider");
  }
  return context;
};

// Provider component
export const EditStateProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isDirty, setIsDirty] = useState(false);
  const [isInvalid, setIsInvalid] = useState(false);
  const [invalidInfo, setInvalidInfo] = useState("");

  const value = {
    isDirty,
    isInvalid,
    setIsDirty,
    setIsInvalid,
    invalidInfo,
    setInvalidInfo,
  };

  return (
    <EditStateContext.Provider value={value}>
      {children}
    </EditStateContext.Provider>
  );
};

export default EditStateProvider;
